<template lang="html">
  <div id="reschedulingPopup" v-if="$store.state.rescherdulingState.isPopupShown">
    <p>振替依頼をする</p>
    <section>
      <ul id="candidate-list">
        <li
          v-for="(cand, index) in candidateDatetimes"
          :key="'list-item-candidate' + index"
          class="list-item list-item-candidate"
        >
        <!--1つの候補日時ボックス-->
        <div class="candidate-box">
          <!--ボックスの見出し-->
          <div class="candidate-caption">
            <div class="candidate-caption-label">
              <label>候補 {{ index + 1 }}</label>
              <div class="candidate-caption-button">
                <el-button
                  class="btn"
                  icon="el-icon-close"
                  :style="{visibility: (candidateDatetimes.length > 1) ? 'visible' : 'hidden'}"
                  @click="deleteCandidate(index)"
                />
              </div>
            </div>
          </div>
          <div class="candidate-body">
            <!--ボックスの見出し 終わり-->
            <!--日付指定部分-->
            <a>日付　　:</a><input type="date" v-model="cand.date"><br>
            <!--日付指定部分 終わり-->
            <!--時間指定方法選択部分-->
            <!--
            <a>時間の指定法:</a>
            <select name="example" v-model="cand.mode">
              <option>1コマ分を指定</option>
              <option>範囲で指定</option>
            </select><br>
          -->
            <!--時間指定方法選択部分 終わり-->
            <!--時間指定部分-->
            <a>開始時間:</a><input type="time" v-model="cand.startTime"><br>
            <a>終了時間:</a><input type="time" v-model="cand.endTime"><br>
            <input type="number" v-model="cand.duration" style="width:20%;"><a>分間</a>
            <!--時間指定部分 終わり-->
          </div>
        </div>
        <!--1つの候補日時ボックス 終わり-->
        </li>
      </ul>
      <input type="button" class="btn" @click="addEmptyCandidate()" value="＋ 候補日時を追加する">
    </section>
    <section>
      <h1 class="section-description">理由を入力してください（必須）</h1>
      <input type="textarea" v-model="reason">
    </section>
    <section v-if="$store.state.userInfo.user_type === 'teacher'">
      <reschedulingOptionForm :reservationOption="reservationOption"/>
    </section>
    <input type="button" @click="onConfirmButtonClicked" value="確認する">
    <input type="button" @click="closePopup" value="cancel">
  </div>
</template>

<script>
import ReschedulingOptionForm from '../../../ReschedulingPage/ReschedulingOptionForm'
import {
  mapGetters,
  mapActions
} from 'vuex'
import {
  RESCHEDULING_POPUP_HIDE
} from '@/vuex/mutation_types'
export default {
  data () {
    return {
      targetReservation: null,
      candidateDatetimes: [
        {
          date: '',
          mode: 'range', // 'slot'または'range'
          startTime: '',
          endTime: '',
          duration: 60
        }
      ],
      reason: '',
      reservationOption: {
        reservationType: '通常',
        hasTest: false,
        reservationMessage: ''
      }
    }
  },
  components: {
    'reschedulingOptionForm': ReschedulingOptionForm
  },
  mounted () {
  },
  methods: {
    ...mapActions([
      'setReschedulingInfo'
    ]),
    closePopup () {
      // popupを閉じる
      this.$store.commit(RESCHEDULING_POPUP_HIDE)
    },
    makeReschedulingInfo () {
      this.targetReservation = {
        classroom: this.$store.state.rescherdulingState.classroom,
        date: this.$store.state.rescherdulingState.date,
        endTime: this.$store.state.rescherdulingState.end,
        hasTest: this.$store.state.rescherdulingState.hasTest,
        id: this.$store.state.rescherdulingState.id,
        isPopupShown: this.$store.state.rescherdulingState.isPopupShown,
        isRecurrent: this.$store.state.rescherdulingState.isRecurrent,
        message: this.$store.state.rescherdulingState.message,
        recurrence_id: this.$store.state.rescherdulingState.recurrence_id,
        reservationType: this.$store.state.rescherdulingState.reservationType,
        startTime: this.$store.state.rescherdulingState.start,
        student: this.$store.state.rescherdulingState.student,
        teacher: this.$store.state.rescherdulingState.teacher,
        school_id: this.$store.state.userInfo.school_id
      }
      let sender = this.$store.state.userInfo.user_id
      let receiver = (sender === this.targetReservation.student) ? this.targetReservation.teacher : this.targetReservation.student
      let targetReservation = this.targetReservation
      return {
        sender: sender,
        receiver: receiver,
        targetReservation: targetReservation,
        candidateDatetimes: this.candidateDatetimes,
        reason: this.reason,
        reservationOption: this.reservationOption
      }
    },
    addEmptyCandidate () {
      this.candidateDatetimes.push({
        date: '',
        mode: 'slot',
        startTime: '',
        endTime: '',
        duration: null
      })
      this.$nextTick(() => {
        let list = document.getElementById('candidate-list')
        list.scrollTop = list.scrollHeight
      })
    },
    deleteCandidate (index) {
      this.candidateDatetimes.splice(index, 1)
    },
    getWeekday (date) {
      return ['日', '月', '火', '水', '木', '金', '土'][date.getDay()]
    },
    onConfirmButtonClicked () {
      if (!this.isFirstCompleted) {
        alert('日時指定に不備があります')
        return
      } else if (!this.isSecondCompleted) {
        alert('理由は必須です')
        return
      } else if (this.$store.state.userInfo.user_type === 'teacher') {
        if (!this.isThirdCompleted) {
          alert('授業の詳細を入力してください')
          return
        }
      }
      // TODO: 確認ページへ
      this.setReschedulingInfo(this.makeReschedulingInfo())
      .then(() => {
        this.closePopup()
      })
      .then(() => {
        this.$router.push('/SpSenderConfirmation')
      })
    }
  },
  computed: {
    ...mapGetters([
    ]),
    isFirstCompleted () {
      for (let candidate of this.candidateDatetimes) {
        if (!candidate.date || !candidate.startTime || !candidate.endTime) {
          return false
        }
      }
      return true
    },
    isSecondCompleted () {
      return !!this.reason
    },
    isThirdCompleted () {
      return this.$store.state.userInfo.user_type === 'teacher' &&
              this.reservationOption.reservationType !== null && this.has_test !== null
    }
  }
}
</script>

<style lang="css" scoped>
#reschedulingPopup{
  position: absolute;
  top: 81px;
  width: 100%;
  min-height: 90vh;
  left: -5px;
  right: 0;
  font-size: 5vw;
  margin: 0px 5px 0px;
  box-sizing: border-box;
  background-color: white;
  border-color: #0065B3;
  border-style: solid;
  border-radius: 5px;
  padding-top: 5px;
  z-index: 1005;
}
.candidate{
  overflow: auto;
  max-height: 20vh;
}
#candidate-list {
  text-align: center;
  overflow: auto;
  max-height: 320px;
  max-width: 500px;
  margin: 10px auto 10px auto;
}
.candidate-box{
  width: 80%;
  margin: auto;
  border: solid 1px rgb(23, 143, 164);
}
.candidate-caption-label{
  text-align: left;
  color: rgb(255, 255, 255);
  font-weight: bold;
  height: 40px;
  background-color: rgb(23, 143, 164)
}
.candidate-body{
  margin: 1vh 0;
}
.candidate-caption-button{
  display: inline-block;
  float: right;
}
</style>



// WEBPACK FOOTER //
// SpReschedulingPopup.vue?5d698a2b